import { LucidServerAPI } from '~api/api';

export const updateOutput = (outputId, output = {}) => LucidServerAPI().patch(`/outputs/${outputId}`, output);
